import React from 'react'
import DataRow from '../../../components/subComponents/DataRow'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

const ProductionPlanDetailWidget = ({ status, prodPlanData }) => {

  const productionPlanHeaders = [
    ['APH' , 'aph'],
    ['Create date', 'created'],
    ['Contract year', 'year'],
    ['Contract type', 'contract_type'],
    ['Delivery location', 'delivery_location'],
    ['Delivery address', 'delivery_address'],
    ['Parent Plan', 'parent_plan'],
    ['Child Plan', 'child_plan'],
    ['Production Plan inventory code', 'inventory_code']
  ]
  
  let data = []
  let dataEntries = Object.entries(prodPlanData)
  dataEntries.forEach(entry => {
    let title = productionPlanHeaders
      .filter(header => header[1] === entry[0])
      .flat()
    data.push({ title: title[0], value: entry[1] })  
  })
  
  let content = status ? <TableStatus status={status} /> : null
  
  if (!content && data.length) {
    content = (
      <>
        <DataRow data={data.slice(0, 3)} />
        <div className='bb1-s-lightgray hide-tablet' />
        <DataRow data={data.slice(3, 6)} /> 
        <div className='bb1-s-lightgray hide-tablet' />
        <DataRow data={data.slice(6, 9)} /> 
      </>
    )
  }
  
  return (
    <Widget
      title={'Production plan details'}>
      {content}
    </Widget>
  )
}

export default ProductionPlanDetailWidget